import { collectionsService } from '@services/firebase/firestore/functionFactory';
import { accountStore } from '@stores/bootstrap-stores/account';
import { mergeRecordsById } from '@utils/mergeRecordsById';
import { FormGroup } from '@vincerosoft/assessfluence-types';
import { orderBy } from 'firebase/firestore';

export const formGroupsGridId = 'formsGroupsGridId';

function formGroupsFactory() {
  async function getFormGroup(id: string) {
    return collectionsService.formGroups.getDoc(id);
  }

  async function getFormGroupsByIds(ids: string[], onProgress: (data: FormGroup[]) => void) {
    const fetchedFormGroups = await collectionsService.formGroups.getDocsInBatches(
      ['id', 'in', ids],
      undefined,
      onProgress
    );

    return fetchedFormGroups.flat();
  }

  async function getFormGroups(_caller: string, onProgress: (formGroups: FormGroup[]) => void) {
    const { scopeQuery, scope, resourceGrants } = accountStore.getState();

    if (['tenant', 'group'].includes(scope)) {
      return collectionsService.formGroups.getDocs(scopeQuery);
    }

    const formGroupGrants = resourceGrants?.formGroups;

    if (!formGroupGrants?.length) {
      return [];
    }

    let progressiveFormGroups: FormGroup[] = [];
    const formGroupIds = formGroupGrants.map((g) => g.resource_id);
    const formGroupBatches = await collectionsService.formGroups.getDocsInBatches(
      ['id', 'in', formGroupIds],
      orderBy('created_at', 'desc'),
      (batchFormGroups) => {
        progressiveFormGroups = mergeRecordsById(
          progressiveFormGroups,
          batchFormGroups as FormGroup[]
        );
        onProgress(progressiveFormGroups);
      }
    );

    return formGroupBatches.flat();
  }

  const extractLinkedFormIds = (formGroups: FormGroup[] | null | undefined) => {
    return (
      formGroups?.reduce((acc, fg) => {
        if (fg?.form_stacks?.length > 0) {
          fg.form_stacks.forEach((form) => {
            if (Array.isArray(form?.form_ids)) {
              acc.push(...form.form_ids);
            }
          });
        }
        return acc;
      }, [] as string[]) || []
    );
  };

  return {
    getFormGroup,
    getFormGroups,
    getFormGroupsByIds,
    extractLinkedFormIds
  };
}

export const formGroupsService = formGroupsFactory();
